<template>

  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">商铺名称:</span>
          <!-- 搜索司机名称-->
          <el-input v-model="search_data.shop_name" placeholder="请输入商铺名称 " class="handle-input mr10"></el-input @keyup.enter.native="searchPartnerLists">
        </el-col>

        <el-col :span="8">
          <!-- 下拉选择城市 -->
          <span class="title">城市:</span>
          <el-select v-model="value_city_code" placeholder="请选择城市" style="width: 150px; margin-right: 20px;"
            @visible-change="cityVisibleChange" @change="cityChange" clearable>
            <el-option v-for="item in options_city_code" :key="item.value" :label="item.city.name"
              :value="item.city.city_code">
            </el-option>
          </el-select>
          <span v-if="company_name!=''">隶属公司:{{ company_name }}</span>
        </el-col>

        <el-col :span="6">
          <el-button :class="more_search?'el-icon-arrow-up':'el-icon-arrow-down'" @click="more_search = !more_search">
            详细搜索
          </el-button>
        </el-col>

      </el-row>


      <el-row class="head-search">

        <el-col :span="24">
          <span class="title">负责人:</span>
          <!-- 搜索司机名称-->
          <el-input v-model="search_data.boss" placeholder="请输入负责人 " class="handle-input mr10" @keyup.enter.native="searchPartnerLists"></el-input>
        </el-col>

      </el-row>

      <div v-show="more_search" style="margin-top: 10px;">

        <el-row class="head-search">
          <el-col :span="24">
            <span class="title">商铺座机:</span>
            <!-- 搜索司机名称-->
            <el-input v-model="search_data.telephone" placeholder="请输入商铺座机 " class="handle-input mr10" @keyup.enter.native="searchPartnerLists"></el-input>
          </el-col>
        </el-row>

        <el-row class="head-search">
          <el-col :span="24">
            <span class="title">负责人电话:</span>
            <!-- 搜索司机名称-->
            <el-input v-model="search_data.phone" placeholder="请输入负责人电话 " class="handle-input mr10" @keyup.enter.native="searchPartnerLists"></el-input>
          </el-col>
        </el-row>

      </div>



      <el-button type="primary" icon="el-icon-search" @click="searchPartnerLists">搜索</el-button>
      <el-button @click="add_isShow=!add_isShow">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>



    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">

      <el-table-column type="selection" width="55" align="center" prop="help_code"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">

            <!-- 表格下拉 -->
            <div class="more-style">

              <el-form-item label="合作商铺地址:">
                <span>{{ props.row.address }}</span>
              </el-form-item>
              <el-form-item label="分润百分比:">
                <span>{{ props.row.profit }}%</span>
              </el-form-item>

            </div>
          </el-form>

        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" width="80px">
      </el-table-column>

      <el-table-column prop="shop_name" label="合作商铺名称" min-width="200px">
      </el-table-column>


      <el-table-column prop="telephone" label="合作商铺座机" min-width="150px">
      </el-table-column>


      <el-table-column prop="name" label="所属城市" width="300">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>城市编码: {{ scope.row.city.city_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.city.name }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>



      <el-table-column prop="boss" label="负责人姓名">
      </el-table-column>

      <el-table-column prop="phone" label="负责人电话" min-width="150px">
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary" @click="edit_isShow = !edit_isShow; help_children = scope.row.help_code;">

            编辑

          </el-button>

        </template>
      </el-table-column>



    </el-table>

    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
      style="margin-top: 20px;">批量删除</el-button>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加组件 -->
    <!-- <addHelp :isShow="add_isShow" @onSubmit="heplLists"></addHelp> -->

    <!-- 添加组件 -->
    <!-- <editHelp :isShow="edit_isShow" :data="help_children" @onSubmit="heplLists"></editHelp> -->


  </div>

</template>

<script>
  var _this;
  // import addHelp from './addHelp.vue';
  // import editHelp from './editHelp.vue';
  export default {
    components: {
      // addHelp,
      // editHelp
    },
    data() {
      return {

        //详细搜索
        more_search: false,

        add_isShow: false,

        edit_isShow: false,

        help_children: '',

        // 批量删除
        delDriverSubmit_data: {
          help_code_array: []
        },
        delDriverSubmit_rules: {
          help_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },

        // 下拉搜索城市
        value_city_code: '',
        options_city_code: [],
        city_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },
        company_name: '',

        val_port_array: '',


        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          city_code: '',
          shop_name: '',
          telephone: '',
          boss: '',
          phone: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.partnerLists();


      // 接收路由传参
      _this.search_data.city_code = _this.$route.query.city_code;

      if (_this.search_data.city_code != undefined) {
        _this.$post(
          "/city/getCityDetails", {
            city_code: _this.search_data.city_code
          }
        ).then(res => {

          _this.value_city_code = res.data.name;
          _this.company_name = res.data.company.name;


        }).catch((err) => {

        })
      }
    },

    methods: {
      searchPartnerLists() {
        _this.search_data.page = 1;
        _this.partnerLists();
      },
      cityChange(val) {

        _this.search_data.city_code = val;
        if (val != '') {

          _this.$post(
            "/city/getCityDetails", {
              city_code: val
            }
          ).then(res => {

            _this.company_name = res.data.company.name;

          }).catch((err) => {

          })

        } else {
          _this.company_name = '';
        }



      },
      //搜索的下拉框弹出触发
      cityVisibleChange(val) {
        if (val && _this.options_city_code.length < 1) {
          // 请求公司管理接口获取公司唯一编码
          _this.$post(
            "/city/cityLists",
            _this.city_options_data
          ).then(res => {
            _this.options_city_code = res.data

          }).catch((err) => {

          })
        }

      },


      // 搜索司机审核列表
      partnerLists() {
        _this.$post(
            "/partner/partnerLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;


          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.partnerLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].help_code);

        }
        _this.delDriverSubmit_data.help_code_array = datalist;
      },
      // 批量删除
      deleteData() {

        if (_this.delDriverSubmit_data.help_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delDriverSubmit_data.help_code_array = JSON.stringify(_this.delDriverSubmit_data
            .help_code_array);

          _this.$post(
              "/help/delHelpSubmit",
              _this.delDriverSubmit_data,
              _this.delDriverSubmit_rules
            )
            .then(res => {

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.partnerLists();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message.info('已取消删除');

        });


      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>